export default "__VITE_ASSET__DszLXDIc__"